<template>
  <div class="keepwarp">
  <el-card class="box-card">
  <div slot="header" class="clearfix">
    <span><i class="el-icon-s-order elcao" ></i>操作手册</span>
  </div>
  <div class="text item">
  <el-table :data="tabledata" border style="width: 100%;min-height:300px"  :header-cell-style="{textAlign: 'center'}" center max-height="670"  :cell-style="{ textAlign: 'center' }">
    <el-table-column type="index" width="50"></el-table-column>
    <el-table-column prop="cmanualname" label="常见问题" ></el-table-column>
     <el-table-column label="操作" width="100">
      <template slot-scope="scope">
        <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)" plain>下载</el-button>
      </template>
    </el-table-column>
  </el-table>
  </div>
</el-card>
  </div>
</template>
<script>
export default {
  data(){
    return{
      tabledata:[]
      
    }
  }
}
</script>







